type ErrorWithData = {
  data?: string | {
    message?: string;
    results?: {
      message?: string;
    };
  };
  error?: string | {
    data?: {
      message?: string;
    };
  };
  message?: string;
};

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (!error) return fallback;

  const err = error as ErrorWithData;

  if (err?.data && typeof err.data === "object") {
    const resultsMessage = err.data.results?.message;
    if (typeof resultsMessage === "string" && resultsMessage.trim().length > 0) {
      return resultsMessage;
    }

    const dataMessage = err.data.message;
    if (typeof dataMessage === "string" && dataMessage.trim().length > 0) {
      return dataMessage;
    }
  }

  // error.data as plain string (some APIs return this)
  if (typeof err?.data === "string" && err.data.trim().length > 0) {
    return err.data;
  }

  // Nested RTK Query error shape: error.error.data.message
  if (err?.error && typeof err.error === "object") {
    const nestedMessage = err.error.data?.message;
    if (typeof nestedMessage === "string" && nestedMessage.trim().length > 0) {
      return nestedMessage;
    }
  }

  if (typeof err?.error === "string" && err.error.trim().length > 0) {
    return err.error;
  }

  const message = err?.message;
  if (typeof message === "string" && message.trim().length > 0) {
    return message;
  }

  return fallback;
};
